module.exports = __webpack_public_path__ + "media/images/icon_rank_01-f27174f6f949a589a25de238a18989cb.png";